<template>
    <div class="row" style="padding-top:20px">
        <div class="list-group" v-for="anl in analysis_list">
            <a href="#" class="list-group-item list-group-item-action flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{anl.package[localize('name')]}}</h5>
                    <div>
                        <small>Cena: {{anl.price_total}} zł</small>
                        <small v-if="anl.is_paid">Opłacone</small>
                        <small v-if="!anl.is_paid">Nieopłacone</small>
                        <button v-if="!anl.is_paid" class="btn-sm btn-dark">Zapłać</button>
                    </div>

                </div>
                <p class="mb-1">
                    Data zamówienia: {{anl.created_at}}
                </p>
                <p class="mb-1">
                    Numer zestawu: {{anl.number}}
                </p>
                <p class="mb-1">
                    Status: {{anl.state[localize('name')]}}
                </p>
            </a>
        </div>
        <div v-if="!analysis_list.length">
            <h4>{{$t('my_analysis.no_analysis_yet')}}</h4>
            <router-link :to="{name:'analysis-order-view'}" class="btn btn-danger" id="order_analysis_link">
                {{$t('order_analysis_label')}}
            </router-link>
        </div>
    </div>
</template>

<script>
    import {FETCH_USER_ANALYSIS} from "../store/actions";
    import {mapGetters} from 'vuex';
    import translatorMixin from '../mixins/translatorMixin';

    export default {
        name: "MyAnalysis",
        mixins: [translatorMixin],
        computed: {
            ...mapGetters(['analysis_list']),
        },
        mounted() {
            this.$store.dispatch(FETCH_USER_ANALYSIS);
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/MyAnalysis.vue